import React from 'react';

function EPHome() {
  return (
    <div>EPHome</div>
  );
}

export default EPHome;
